export const formatNumber = (input?: number | string) => {
  if (typeof input === 'string' || typeof input === 'number') {
    return Number(input).toLocaleString();
  }
  return input;
};
